import { parsePhoneNumber } from 'libphonenumber-js/max';

const POLISH_NATIONAL_NUMBER_DIGITS_AMOUNT = 9;

export const isValidPhoneNumberLength = (phoneNumber: string) => {
    const parsedNationalNumber = parsePhoneNumber(phoneNumber, 'PL').nationalNumber;
    return parsedNationalNumber.length === POLISH_NATIONAL_NUMBER_DIGITS_AMOUNT;
};
